// ── 최근계약현황 관리 섹션 ─────────────────────────────────
// (미팅인계 담당자 블록은 미팅지도 관리 ⚙️ 설정 모달로 이관 — 2026-09-01)
import React from 'react';
import { RecentContractsSection } from './RecentContractsSection';

export function PersonsAndWorkflowSection({
  // 최근계약현황 직원별 설정
  rcConfig, rcConfigLoading,
  rcUserSettings, rcSavingUserId,
  setRcUserMonths, toggleRcUserTicketType, saveRcUserSettings,
  personsSaving: saving,
}) {
  return (
    <>
      {/* 지역 색상 기준은 방문빈도 관리 ⚙️ 설정으로 옮겼다 (2026-09-17 사용자 요청) */}

      {/* ── 최근계약현황 관리 ── */}
      <RecentContractsSection
        rcConfig={rcConfig}
        rcConfigLoading={rcConfigLoading}
        rcUserSettings={rcUserSettings}
        rcSavingUserId={rcSavingUserId}
        setRcUserMonths={setRcUserMonths}
        toggleRcUserTicketType={toggleRcUserTicketType}
        saveRcUserSettings={saveRcUserSettings}
        saving={saving}
      />
    </>
  );
}
